import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { sponsor1, sponsor2, sponsor3, sponsor4, sponsor5 } from "../../lib/images";
import "./sponsorBanner.styles.scss";

function SponsorBanner() {
  return (
    <div>
      <div id="about-us">
        <Container className="sponsor-banner">
          <Row noGutters>
            <Col xs="12">
              <Container className="sponsor-container d-none d-lg-block">
                <Row
                  noGutters
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-around",
                  }}
                >
                  <Col xs={6} md={6} lg={6} xl={4}>
                    <a
                      className={sponsor1.link ? "" : "disable-link"}
                      href={sponsor1.link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Image src={sponsor1.src} alt={sponsor1.altTxt} />
                    </a>
                  </Col>
                  <Col xs={6} md={6} lg={6} xl={4}>
                    <a
                      className={sponsor2.link ? "" : "disable-link"}
                      href={sponsor2.link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Image src={sponsor2.src} alt={sponsor2.altTxt} />
                    </a>
                  </Col>
                  <Col xs={6} md={6} lg={6} xl={4}>
                    <a
                      className={sponsor3.link ? "" : "disable-link"}
                      href={sponsor3.link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Image src={sponsor3.src} alt={sponsor3.altTxt} />
                    </a>
                  </Col>
                  <Col xs={6} md={6} lg={6} xl={4}>
                    <a
                      className={sponsor4.link ? "" : "disable-link"}
                      href={sponsor4.link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Image src={sponsor4.src} alt={sponsor4.altTxt} />
                    </a>
                  </Col>
                  <Col xs={6} md={6} lg={6} xl={4}>
                    <a
                      className={sponsor5.link ? "" : "disable-link"}
                      href={sponsor5.link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Image src={sponsor5.src} alt={sponsor5.altTxt} />
                    </a>
                  </Col>
                </Row>
              </Container>
              <Container className="sponsor-container d-lg-none">
                <Row
                  noGutters
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-around",
                  }}
                >
                  <Col xs={4} md={6} lg={3} xl={3}>
                    <a
                      className={sponsor1.link ? "" : "disable-link"}
                      href={sponsor1.link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Image src={sponsor1.src} alt={sponsor1.altTxt} />
                    </a>
                  </Col>
                  <Col xs={4} md={6} lg={3} xl={3}>
                    <a
                      className={sponsor2.link ? "" : "disable-link"}
                      href={sponsor2.link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Image src={sponsor2.src} alt={sponsor2.altTxt} />
                    </a>
                  </Col>
                  <Col xs={4} md={6} lg={3} xl={3}>
                    <a
                      className={sponsor3.link ? "" : "disable-link"}
                      href={sponsor3.link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Image src={sponsor3.src} alt={sponsor3.altTxt} />
                    </a>
                  </Col>
                  <Col xs={4} md={6} lg={3} xl={3}>
                    <a
                      className={sponsor4.link ? "" : "disable-link"}
                      href={sponsor4.link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Image src={sponsor4.src} alt={sponsor4.altTxt} />
                    </a>
                  </Col>
                  <Col xs={4} md={6} lg={3} xl={3}>
                    <a
                      className={sponsor5.link ? "" : "disable-link"}
                      href={sponsor5.link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Image src={sponsor5.src} alt={sponsor5.altTxt} />
                    </a>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default SponsorBanner;
